import { AvailableIcons } from '@ap/icon';

import { SignToken, SignTokenBrowserRegister } from '../../sign.model';

export interface TokenType {
    name: string;
    icon: AvailableIcons;
    ids: SignToken[];
    disabled?: boolean;
    helpText?: string;
    redirect?: boolean;
}

export const selectorTypes: TokenType[] = [
    {
        name: 'digipas',
        icon: 'digipas',
        ids: [SignToken.DIGIPAS]
    },
    {
        name: 'digicode',
        icon: 'digicode',
        ids: [SignToken.DIGICODE]
    },
    {
        name: 'prospect_digicode',
        icon: 'digicode',
        ids: [SignToken.PROSPECT_DIGICODE]
    },
    {
        name: 'device',
        icon: 'qrcode',
        ids: [SignToken.NATIVE_APP]
    },
    {
        name: 'browser',
        icon: 'browsercode',
        ids: [SignToken.BROWSER]
    },
    {
        name: SignTokenBrowserRegister,
        icon: 'browsercode',
        ids: [SignToken.BROWSER],
        redirect: true
    },
    {
        name: 'phone',
        icon: 'mobile',
        ids: [SignToken.PHONE_NUMBER]
    },
    {
        name: 'phone.device',
        icon: 'qrcode',
        ids: [SignToken.PHONE_NUMBER, SignToken.NATIVE_APP]
    },
    {
        name: 'phone.browser',
        icon: 'digicode-settings',
        ids: [SignToken.PHONE_NUMBER, SignToken.BROWSER]
    },
    {
        name: 'phone.digipas',
        icon: 'digipas',
        ids: [SignToken.PHONE_NUMBER, SignToken.DIGIPAS]
    },
    {
        name: 'phone.digicode',
        icon: 'digicode',
        ids: [SignToken.PHONE_NUMBER, SignToken.DIGICODE]
    },
    {
        name: 'phone.prospect_digicode',
        icon: 'digicode',
        ids: [SignToken.PHONE_NUMBER, SignToken.PROSPECT_DIGICODE]
    }
];
